import React from 'react';
import {styles} from './styles';
import ValueController from './valueController';

export default function ToteRowItemsControllers({initialValue = 0, onUpdate}) {
  return (
    <ValueController
      initialValue={initialValue}
      onUpdate={onUpdate}
      minValue={1}
      maxValue={10}
      containerStyle={styles.toteCountContainer}
      inputStyle={styles.toteCountInput}
      testIdPrefix="toteCount"
    />
  );
}
